import React from 'react';
import Select from 'react-select';

function DropdownSelectComponent({ styles = {}, colors, options, selectedOptions, onChange, config, data }) {
  const { className, components = {}, ...reactSelectProps } = config;
  return (
    <Select
      styles={mergeStyles(getSelectStyles(colors), styles)}
      className={className}
      classNamePrefix={className}
      options={options}
      value={selectedOptions}
      onChange={onChange}
      components={components}
      {...reactSelectProps}
      data={data}
    />
  );
}

export default DropdownSelectComponent;

const borderRadiusValue = '10px';

function mergeStyles(selectStyles, styles) {
  return {
    ...selectStyles,
    ...styles,
  };
}

const getSelectStyles = function (colors) {
  return {
    control: (styles, { menuIsOpen }) => ({
      ...styles,
      background: colors.primary.light,
      border: `1px solid ${colors.primary.default}`,
      borderColor: colors.primary.default,
      borderRadius: borderRadiusValue,
      borderBottomRightRadius: menuIsOpen ? '0' : borderRadiusValue,
      borderBottomLeftRadius: menuIsOpen ? '0' : borderRadiusValue,
      boxShadow: 'none',
      cursor: 'pointer',

      '&:hover': {
        borderColor: colors.primary.default,
      },
    }),
    valueContainer: (styles) => ({
      ...styles,
      paddingLeft: '12px',
    }),
    singleValue: (styles) => ({
      ...styles,
      fontSize: '1.4em',
      fontWeight: 500,
      color: colors.text.default,
    }),
    menu: (styles) => ({
      ...styles,
      marginTop: '0',
      border: `1px solid ${colors.primary.default}`,
      borderWidth: '0 1px 1px 1px',
      borderRadius: borderRadiusValue,
      borderTopRightRadius: '0',
      borderTopLeftRadius: '0',
      boxShadow: '0px 3px 18px 0 rgba(0, 0, 0, 0.11)',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isFocused ? colors.primary.light : colors.background.light,
      fontSize: '1.4em',
      fontWeight: isSelected ? 700 : 500,
      color: colors.text.default,
      cursor: 'pointer',
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    indicatorsContainer: (styles, { selectProps }) => ({
      ...styles,
      transform: selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.3s ease-out',
    }),
  };
};
